import { render, staticRenderFns } from "./TaskTypeSelector.vue?vue&type=template&id=3cf7f250&scoped=true&"
import script from "./TaskTypeSelector.vue?vue&type=script&lang=js&"
export * from "./TaskTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf7f250",
  null
  
)

export default component.exports